import React , { Component } from 'react';
import './App.css';
import logo from './img/logo.png';
import {
  Container,Row,Col
} from 'reactstrap';
import About from './img/about.png';import Service from './img/service.png';
import Products from './img/products.png';import Contact from './img/contact.png';import News from './img/news.png';
import Twitter from './img/twiter.png';import fb from './img/fb.png';
import ig from './img/ig.png'; import gplus from './img/gplus.png';import yt from './img/yt.png';

export default class Footer extends Component {
    render() {
        return (
            <div>
              <section id="row-list"></section>
              <section id="footer">
                <Container>
                    <Row className="row-list"></Row>
                   <Row >
                       <Col sm="3" >
                       Menu<br/>
                         <a href="/about"><p><img className="foot" src={About}/>{' '}About</p></a>
                         <a href="/service"><p><img className="foot" src={Service}/>{' '}Service</p></a>
                         <a href="/products"><p><img className="foot" src={Products}/>{' '}Products</p></a>
                         <a href="/contact"><p><img className="foot" src={Contact}/>{' '}Contact</p></a>
                         <a href="/berita"><p><img className="foot" src={News}/>{' '}Berita</p></a>
                      </Col>
                      <Col sm="6" align="center">
                        <a href="/">
                          <img src={logo} style={{width:"80%"}} />
                        </a> <br/><br/><br/><br/>
                        &copy; <b>AGUSTIAN TECNO</b><br/>
                        jl.usaha dulu No.1, Indramayu 45264<br/>
                        belumadaemail@agtchno.com{' '}|{' '}fax.(022)2345678
                      </Col>
                      <Col sm="3" align="right">
                        Lets stay connect !<br/>
                        <a target="_blank" href=""><p>twitter{' '}<img className="foot" src={Twitter}/></p></a>
                        <a target="_blank" href="https://www.facebook.com/profile.php?id=100008456045849"><p>facebook{' '}<img className="foot" src={fb}/></p></a>
                        <a target="_blank" href="https://www.instagram.com/ilhamnuragustian/?hl=id"><p>instagram{' '}<img className="foot" src={ig}/></p></a>
                        <a target="_blank" href="https://plus.google.com/u/0/111708346090054722588"><p>Google+{' '}<img className="foot" src={gplus}/></p></a>
                        <a target="_blank" href="https://www.youtube.com/channel/UCTdboeOtk4ANO5FEnUCH4uw?view_as=subscriber"><p>Youtube{' '}<img className="foot" src={yt}/></p></a>
                      </Col>
                    </Row>
                </Container>
              </section>
              <Col sm="12" className="copyright text-center">
              &copy; 2018 AGUSTIAN TECHNO. All right reserved | <a href="https://plus.google.com/u/0/111708346090054722588">Ilham Nur Agustian</a>
                </Col>
            </div>
    );
  }
  }
   


// WEBPACK FOOTER //
// ./src/footer.js